import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import 'react-phone-number-input/style.css';
import { connect } from 'react-redux';
import { Button, Grid, Loader, Icon } from 'semantic-ui-react';
import { GetActiveSubcriptionDataAction } from '../../../app/ActionsImpl';
import { ADMIN_API_HOST } from '../../../constants';

const CheckoutForm = ({
  onSuccess,
  representation,
  representationPrice,
  templateToken,
  activeSubscription,
  GetActiveSubscription,
  clearSteps,
  templateId,
  selectedSteps,
  orderToEdit,
  user
}) => {
  const [formData, setFormData] = useState({});
  const [subscriptionPolling, setSubscriptionPolling] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const formRef = useRef(null);


  const handleSubmit = async (event) => {
    event?.preventDefault();
    console.log("submit")
    onSuccess({
      ...formData,
      orderToEditId: orderToEdit?._id,
      templateId,
      selectedSteps,
      kontakt_email: user?.attributes?.email
    });
  };

  const handleSubscription = async () => {
    const newWindow = window.open("/user-profile?page=predplatne&return=true", '_blank')


    setRedirecting(true);

    setTimeout(() => {
      setRedirecting(false);
    }, 5000);
    setSubscriptionPolling(true);
    console.log(formRef)
    console.log(formRef?.current)
    const intervalId = setInterval(async () => {
      try {
        let result = await axios
          .get(ADMIN_API_HOST + "/stripe-customer/get-active")
          .then((response) => response.data);

        console.log(result)
        if (result?.active) {
          GetActiveSubscription()
          clearInterval(intervalId);
          setSubscriptionPolling(false)
          formRef.current?.requestSubmit?.();
          console.log("Predplatné je aktívne!");
          // Môžeš napríklad presmerovať alebo zobraziť notifikáciu
        }
      } catch (err) {
        console.error("Chyba pri pollingu:", err);
      }
    }, 15000);
  }

  useEffect(() => {
    if (activeSubscription?.active && formRef.current) {
      formRef.current?.requestSubmit?.();
    }
  }, [activeSubscription]);

  return (
    <div className="orderForm subscription-modal">
      <Grid container centered style={{ marginTop: 10 }}>
        <Grid.Column mobile={15} widescreen={15}>
          <h3 className="orderHeading"><Icon color='red' name='ban' /> Nemáte aktívne predplatné</h3>
          <div>
            {redirecting ?
              <Loader active inline="centered" size="large">
                Otváram v novom okne...
              </Loader>
              :
              <form ref={formRef} onSubmit={handleSubmit} className="orderUiForm">
                {!activeSubscription?.active ? (
                  <>
                    {subscriptionPolling && (
                      <Loader active inline="centered" size="large">
                        Načítava sa predplatné...
                      </Loader>
                    )}
                    <div className='contracts-benefits'>
                      <div className="subtitle">Pre vytváranie zmlúv potrebujete mať aktívne predplatné. S predplatným získate:</div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /> <span><b>Elektronické podpisovanie</b> KEP-om aj iba elektronickým podpisom</span></div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /> <span><b>Neobmedzený prístup</b> k tvorbe zmlúv</span></div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /> <span>Vždy aktuálne údaje z registra podnikateľov(RPO)</span></div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /> <span>Okamžité generovanie a úpravy dokumentov</span></div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /><span>Bezpečné uloženie a <b>archiváciu zmlúv</b></span></div>
                      <div className="pricingDescription"><Icon color='green' name='check circle' /><span>Právne aktuálne vzory <b>pripravené odborníkmi</b></span></div>
                      <div className="subfooter">Nenechajte sa obmedzovať. Aktivujte si predplatné a využívajte službu naplno!</div>
                    </div>
                    <Button
                      onClick={handleSubscription}
                      className="ui primary big button confirmOrderButton"
                      type="button"
                    >
                      Aktivovať predplatné
                    </Button>
                  </>
                ) : null}
              </form>
            }
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

const mapStateToProps = ({ appState }) => ({
  company: appState.company,
  allowInvoiceOtherCompany: appState.allowInvoiceOtherCompany,
  user: appState.cognitoUser,
  userOrdersCount: appState.userOrdersAmount,
  templateToken: appState.token,
  activeSubscription: appState.activeSubscription,
  orderToEdit: appState.orderToEdit
});

const mapDispatchToProps = {
  GetActiveSubscription: GetActiveSubcriptionDataAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);